import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Notification } from '../../../common/notification'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { Header } from './components/Header'
import { ListInfo } from './components/ListInfo'
import { ChartTotalAlert } from './components/chart'
import { dataTotalAlert, loadingTotalAlert } from './store/slice'
import { getTotalAlert } from './store/thunk'

export const TotalAlerts = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(loadingTotalAlert('totalAlert'))
  const data = useSelector(dataTotalAlert)

  useEffect(() => {
    dispatch(getTotalAlert())
  }, [locale])

  return (
    <LayoutPanel className="h100" loading={loading}>
      <div className="wh100 flexColumn gap2">
        <Header isNoData={!Object.keys(data).length} />
        {!Object.keys(data).length ? (
          <Notification value="dashboard.totalAlert.noData" />
        ) : (
          <>
            <ListInfo />
            <div className="wh100 dFlex alignItemsCenter">
              <ChartTotalAlert />
            </div>
          </>
        )}
      </div>
    </LayoutPanel>
  )
}
